<section>
  <div class="footer-container">
    <span>Copyright © HASEKO Corporation. All Rights Reserved.</span>
  </div>
</section>
